// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"nASE6sh71wQUBd91Esjah","valueBox":"_3kI6806YKOCRpsMCYDI8wT"};